import React from 'react';
import classNames from 'classnames';

export default function FormInput({
maxLength,
  label,
  name,
  type = 'text',
  value,
  onChange,
  error,
  textarea = false,
  
}) {
  const inputClass = classNames('form-control', {
    'border-red-500': error,
  });

  return (
    <div className="form-group">
      {textarea ? (
        <textarea
         maxLength={maxLength}
          name={name}
          placeholder={label}
          value={value}
          onChange={onChange}
          className={inputClass}
          rows={7}
         
        />
      ) : (
        <input
         maxLength={maxLength}
          type={type}
          name={name}
          placeholder={label}
          value={value}
          onChange={onChange}
          className={inputClass}
          
        />
      )}
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
}
